(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Custom-Category-Carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  $('.carousel-slider').slick({
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 3000,
    prevArrow: $('.slick-prev'),
    nextArrow: $('.slick-next'),
    dots: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true
        }
      }
    ]
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const waitForSlick = () => {
    if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
      setTimeout(waitForSlick, 100);
    } else {
      $('.brand-carousel').not('.slick-initialized').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        dots: false,
        infinite: true,
        centerMode: true,
        variableWidth: true, // KEY: allow each image to keep natural width
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              centerMode: false,
              variableWidth: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              centerMode: false,
              variableWidth: true
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              centerMode: false,
              variableWidth: true
            }
          }
        ]
      });
    }
  };
  waitForSlick();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const $carousel = $('.carousel-slider');

  function initSlickMobileOnly() {
    if (window.innerWidth <= 768) {
      if (!$carousel.hasClass('slick-initialized')) {
        $carousel.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          autoplay: true,
          autoplaySpeed: 3000,
          prevArrow: $('.slick-prev'),
          nextArrow: $('.slick-next'),
          dots: false,
          infinite: true
        });
      }
    } else {
      if ($carousel.hasClass('slick-initialized')) {
        $carousel.slick('unslick');
      }
    }
  }

  initSlickMobileOnly();
  window.addEventListener('resize', initSlickMobileOnly);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-two-images"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  $('.carousel-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 4000,
    prevArrow: $('.slick-prev'),
    nextArrow: $('.slick-next'),
    dots: false,
    infinite: false
  });
});

  } catch(e) { console.error(e); }
})();
})();
